import { render, staticRenderFns } from "./SalesModuleMenu.vue?vue&type=template&id=b6c03bf0&"
import script from "./SalesModuleMenu.vue?vue&type=script&lang=js&"
export * from "./SalesModuleMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports